import { Injectable } from '@angular/core';
import { BaseService, Pagination } from '../core';
import { DisplayCategory, SearchDto, PopularSearch, Product, Brand, ProductListDto } from '../dto';
import { Store } from '@ngrx/store';
import * as IndicatorStore from '../store/indicator';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService extends BaseService {
  constructor(private store: Store<any>) {
    super();
  }

  getSearch(keyword: string) {
    return super.get<SearchDto[]>('/search', { keyword });
  }

  getSearchProduct(productListDto: ProductListDto, paginate: Pagination) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('cancelPurchaseOrder'));
    return super.paginate<Product>('/search/product', productListDto, paginate).pipe(
      mergeMap((pagenatedProduct) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('cancelPurchaseOrder'));
        return of(pagenatedProduct);
      })
    );
  }

  getSearchBrand(productListDto: ProductListDto) {
    return super.get<Brand[]>('/search/brand', productListDto);
  }

  getSearchAllBrand(productListDto: ProductListDto) {
    return super.get<Brand[]>('/search/all-brand', productListDto);
  }

  getSearchAllDisplayCategory(productListDto: ProductListDto) {
    return super.get<DisplayCategory[]>('/search/all-display-category', productListDto);
  }

  getPopularSearch() {
    return super.get<PopularSearch[]>('/popular-search');
  }
}
